var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.2,
    height: 11.247,
    viewBox: "0 0 14.2 11.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Messages",
    d: "M10.719,65.047H3.281A3.285,3.285,0,0,1,0,61.766V57.281A3.285,3.285,0,0,1,3.281,54h7.437A3.285,3.285,0,0,1,14,57.281v4.484A3.285,3.285,0,0,1,10.719,65.047ZM3.281,55.094a2.19,2.19,0,0,0-2.187,2.188v4.484a2.19,2.19,0,0,0,2.187,2.187h7.437a2.19,2.19,0,0,0,2.188-2.187V57.281a2.19,2.19,0,0,0-2.188-2.187ZM9,60.492l2.7-2.065a.547.547,0,0,0-.664-.869l-2.7,2.065a2.193,2.193,0,0,1-2.651,0L3.07,57.588a.547.547,0,0,0-.671.864L5.02,60.489l0,0a3.289,3.289,0,0,0,3.98,0Z",
    transform: "translate(0.1 -53.9)",
    fill: "#474461",
    stroke: "#fff",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.7fa29d86da9db2518898e60344e1d588.svg";
export { ForwardRef as ReactComponent };